<template>
  <!-- v-intersect="onintersect" -->
  <div
    v-if="train.closed && taktarea_index === 0 || !train.closed"
    class="taktarea-intersection-placeholder"
    :style="`
      width: calc((${multiproject_calendar.dates.length + 2} * (var(--workpackage_width) + 8px) + var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px) * var(--taktplan_zoom));
      `"
    >
    <Taktarea
      v-if="taktarea && ((show_taktarea || taktarea_index === 0) && (train.closed && taktarea_index === 0 || !train.closed))"
      :id="`taktarea${taktarea.id}`"
      :ref="`taktarea${taktarea.id}`"
      :key="`taktarea${taktarea.id}`"
      :project_length="multiproject_calendar.dates.length"
      :no_border="true"
      header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
      >
      <template #taktarea_header>
        <!-- Header name: Train open -->
        <template v-if="!train.closed">
          <HeaderTrainOpen
            style="border-style: solid;
            border-width: 1px 0px 0px 0px; border-color: black !important"
            v-if="taktarea_index === 0"
            :taktarea_count="train.closed?1:train.taktareas.length"
            @click.native="
              updateUDObject({
                url: [
                  {projects: project_id},
                  {trains: train.id},
                ],
                update: {
                  closed: !train.closed
                }
              })"
            >
            <div>{{train.name}}</div>
          </HeaderTrainOpen>
          <div v-else style="width: calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"/>
        </template>
        <HeaderRow
          v-if="train.closed"
          style="height: 100%; border-style: solid;
          border-width: 0px 0px 1px 0px; border-color: var(--header_border_color) !important"
          :z_index="6"
          width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
          sticky_left="0px"
          :text="train.name"
          :key="`trainname${train.id}`"
          :color="train.closed?'color-1-5':''"
          text_color="primary"
          :readonly="true"
          @click.native="
            updateUDObject({
              url: [
                {projects: project_id},
                {trains: train.id}
              ],
              update: {
                closed: false
              }
            })"
          />
        <HeaderRow
          v-if="!train.closed"
          style="height: 100%; "
          z_index="6"
          sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
          width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
          :key="`taktareaname${taktarea.id}`"
          class="color-1"
          inner_border="solid 1px rgba(255,255,255,0.8)"
          :text="taktarea.name"
          :readonly="true"
          />
        <HeaderPlaceholder
          v-else
          class="cursor-pointer"
          width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
          height="calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom))"
          z_index="4"
          sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
          style="overflow: hidden; height: 100%"
          @click.native="updateUDObject({
              url: [
                {projects: project_id},
                {trains: train.id}
              ],
              update: {
                closed: false
              }
            })"
          >
          <TrainHead :zoom="0.3" :color="$vuetify.theme.dark?'rgba(255,255,255,0.9)':'color-0'"/>
          <div style="margin: 0px 2px 0px 2px">{{train.taktareas.length}}</div>
          <TrainTail :zoom="0.3" :color="$vuetify.theme.dark?'rgba(255,255,255,0.9)':'color-0'"/>
        </HeaderPlaceholder>
      </template>
      <template #taktarea v-if="taktarea.twaggons">
        <!-- <MPWaggon
          v-for="waggon in getUObjects({type: 'twaggons', ids: taktarea.twaggons})"
          :key="`waggon${waggon.id}`"
          :waggon="waggon"
        /> -->
          <div
            class="multi-waggon color-3"
            v-for="waggon in getUObjects({type: 'twaggons', ids: taktarea.twaggons})"
            :key="`waggon${waggon.id}`"
            :style="`
              left: calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom) + (var(--workpackage_width) + 8px) * var(--taktplan_zoom) + (${multiproject_calendar.lookup[waggon.takt_start_date]} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom)));
              width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom) * ${waggon.length} + ${waggon.length > 1?`(2px * var(--taktplan_zoom) * 2 * ${waggon.length - 1})`:'0px'});
              `"
            >
            <div v-if="$store.state.View.isTokenView" class="token-view">
              {{ waggon.token ? waggon.token : ''}}
            </div>
            <div v-if="$store.state.View.isMPStatusView" class="token-view">
              <v-icon
                v-if="getTWaggonStatus(waggon.id).value !== 'none'"
                :size="25 * $store.state.View.taktplan_zoom"
                :color="getTWaggonStatus(waggon.id).value === 'stop' ? 'red':'snow'"
              >
                {{ getTWaggonStatus(waggon.id).icon }}
              </v-icon>
            </div>
            <div class="waggon-grid" :style="`grid-template-columns: ${gridColumns(waggon.tworkpackages.length)}`">
              <div
                v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                :key="`tworkpackages${workpackage.id}`"
                :class="`multi-workpackage ${workpackage.color}`"
                :style="`${wp_dimensions(waggon.tworkpackages.length, waggon.length)} ${workpackage.textcolor?`color: ${workpackage.textcolor};`:'color: black;'}`"
              >

                <StandardBadge
                    v-if="$store.state.View.show_wp_status_multiproject && (workpackage.status !== 'none' || workpackage.stop_status !== 'none')"
                    :key="`workpackagebadge${workpackage.id}`"
                    :icon="workpackage.stop_status !== 'none'?(workpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'):getStatusArray.find(status => status.name === workpackage.status).icon"
                    color="white"
                    :content_color="workpackage.stop_status !== 'none' ? 'red':'black'"
                  />

                {{workpackage.token}}
              </div>
            </div>
          </div>
      </template>
    </Taktarea>
  </div>
</template>
<script>
  import { mapGetters, mapActions, mapState } from 'vuex';

  // import MPWaggon from '@/views/MultiProject/MPWaggon.wrapper.vue';

  import Taktarea from '@/components/ProjectTaktPlan/TaktArea.component.vue';
  import HeaderRow from '@/components/ProjectTaktPlan/HeaderRow.component.vue';
  import HeaderPlaceholder from '@/components/ProjectTaktPlan/HeaderPlaceholder.component.vue';
  import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
  import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
  import HeaderTrainOpen from '@/components/ProjectTaktPlan/HeaderTrainOpen.component.vue';
  import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
  // import MPWaggon from '@/views/MultiProject/MPWaggon.wrapper.vue';

  export default {
    props: ['project_id', 'train', 'train_index', 'taktarea', 'taktarea_index'],
    components: {
      // MPWaggon,
      Taktarea,
      HeaderRow,
      HeaderPlaceholder,
      TrainHead,
      TrainTail,
      HeaderTrainOpen,
      StandardBadge,
      // MPWaggon,
    },
    data: () => ({
      show_taktarea: true,
    }),
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      ...mapGetters('Project', [
        'getStatusArray',
      ]),
      ...mapGetters('TWaggon', [
        'getTWaggonStatus',
      ]),
      ...mapState('MultiProject', [
        'multiproject_calendar'
      ])
    },
    methods: {
      ...mapActions('UltraDev', [
        'updateUDObject'
      ]),
      onintersect(entries, observer, isIntersecting) {
        if (isIntersecting) {
          this.show_taktarea = true;
        } else {
          this.show_taktarea = false;
        }
      },
      gridColumns(workpackage_count) {
          let column_count = 2
          if (workpackage_count !== 2) {
            column_count = Math.ceil(workpackage_count/2)
          }
          return `repeat(${column_count}, ${100/column_count}%)`
      },
      wp_dimensions(workpackage_count, waggon_duration) {
            let column_count = 2
            let row_count = 1
            if (workpackage_count !== 2) {
              column_count = Math.ceil(workpackage_count/2)
            }
            if (workpackage_count > 2) {
              row_count = 2
            }
            return `width: calc(var(--workpackage_width) * var(--taktplan_zoom) * ${waggon_duration?waggon_duration:1} / ${column_count} ${waggon_duration?`2px * var(--taktplan_zoom) * ${waggon_duration} / ${column_count}`:''});
                    height: calc(var(--workpackage_height) * var(--taktplan_zoom) / ${row_count});
                    line-height: calc(var(--workpackage_height) * var(--taktplan_zoom) / ${row_count});
                    margin: calc(2px * var(--taktplan_zoom) / ${row_count}) calc(2px * var(--taktplan_zoom) / ${column_count});`
      }
    }
  }
</script>
<style>
.taktarea-intersection-placeholder {
  height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom));

  /* height: 42px; */
  /* width: 100%; */
  /* background-color: green; */
}
.multi-waggon {
  position: absolute;
  border-radius: calc(4px * var(--taktplan_zoom)) !important;
  margin: calc(2px * var(--taktplan_zoom));
  /* width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom)); */
  height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom));
}
.waggon-grid {
  display: grid;
}
.multi-workpackage {
  position: relative;
  width: calc(var(--workpackage_width) * var(--taktplan_zoom));
  height: calc(var(--workpackage_height) * var(--taktplan_zoom));
  border-radius: calc(3px * var(--taktplan_zoom)) !important;
  margin: calc(2px * var(--taktplan_zoom));
  font-size: calc(12px * var(--taktplan_zoom));
  user-select: none;
  text-align: center;
  vertical-align: middle;
}
.token-view {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgb(106 106 106 / 60%);
  z-index: 2;
  font-size: calc(30px * var(--taktplan_zoom)) !important;
}
</style>
